import { useUpdateClient } from 'app/features/profile/accountInfo/editAccountInfo';
import {
  useDeleteAllDependentMutation,
  useDeleteDependentMutation,
} from 'app/services/user';
import { AddIcon, CancelIcon } from 'assets/icons';
import { CustomButton } from 'Components/Auth/CustomButton';
import DateInputBasic from 'Components/Form/Basic/DateInputBasic';
import { MaskedInputBasic } from 'Components/Form/Basic/MaskedInputBasic';
import { RadioInputBasic } from 'Components/Form/Basic/RadioInputBasic';
import { SelectInputBasic } from 'Components/Form/Basic/SelectInputBasic';
import { TextInputBasic } from 'Components/Form/Basic/TextInputBasic';
import { errorToast, successToast } from 'Components/Notifications';
import Spinner from 'Components/Spinner';
import { uniqueId } from 'lodash';
import React, { useEffect } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

export const RelationshipOptions = [
  { label: 'Adopted', value: 'adopted' },
  { label: 'Child', value: 'child' },
  { label: 'Aunt', value: 'aunt' },
  { label: 'Brother', value: 'brother' },
  { label: 'Daughter', value: 'daughter' },
  { label: 'Father', value: 'father' },
  { label: 'Foster Child', value: 'foster_child' },
  { label: 'Grandchild', value: 'grandchild' },
  { label: 'Grandparent', value: 'grandparent' },
  { label: 'Mother', value: 'mother' },
  { label: 'Nephew', value: 'nephew' },
  { label: 'Niece', value: 'niece' },
  { label: 'None', value: 'none' },
  { label: 'Other', value: 'other' },
  { label: 'Parent', value: 'parent' },
  { label: 'Sister', value: 'sister' },
  { label: 'Son', value: 'son' },
  { label: 'Stepchild', value: 'stepchild' },
  { label: 'Uncle', value: 'uncle' },
];

export default function DependentStep() {
  const { UpdateClient, client } = useUpdateClient();
  const [DeleteAllDependent] = useDeleteAllDependentMutation();
  const [DeleteDependent] = useDeleteDependentMutation();

  let [DeletedDep, setDeletedDep] = React.useState([] as any);
  let [HaveDep, setHaveDep] = React.useState();
  let navigate = useNavigate();

  let emptyData = {
    relationship: '',
    firstname: '',
    lastname: '',
    ssn: undefined,
    birth_date: '',
    id: uniqueId(),
  };
  let { register, handleSubmit, control, watch, getValues } = useForm<any>({
    defaultValues: {
      dependents: client?.dependents?.map((dep) => ({
        serverId: dep?.id,
        relationship: dep?.relationship,
        firstname: dep?.firstname,
        lastname: dep?.lastname,
        ssn: dep?.ssn,
        birth_date: dep?.birth_date,
        id: uniqueId(),
      })),
      HaveDependent:
        client?.dependents && client.dependents?.length > 0 ? 'yes' : 'no',
    },
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'dependents',
  });
  const watchFieldArray = watch('dependents');
  const watchHaveDep = watch('HaveDependent');
  useEffect(() => {
    setHaveDep(getValues('HaveDependent'));
  }, [watchHaveDep]);

  if (!client) return <Spinner />;

  const controlledFields = fields.map((field, index) => {
    return {
      ...field,
      ...watchFieldArray[index],
    };
  });
  const onSubmit = async (data: any) => {
    let result = data.dependents
      .filter((item: any) => {
        return JSON.stringify(item) !== JSON.stringify(emptyData);
      })
      .map((res: any) => {
        res.id = res.serverId;
        delete res.serverIDd;
        return res;
      });
    try {
      if (data.HaveDependent === 'yes' && result) {
        const promises = DeletedDep.map((id: any) => DeleteDependent(id));
        navigate('..');
        await Promise.allSettled(promises);
        await UpdateClient({
          dependents_attributes: result,
        });
        successToast('Dependent Information Updated Successfully');
      } else {
        await DeleteAllDependent().then(async () => {
          await successToast('Dependent Information Updated Successfully');
          navigate('..');
        });
      }
    } catch (error: any) {
      errorToast(error);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <>
        <div className="flex mb-3 ">
          <div className="w-1/3 md-max:w-full">
            <RadioInputBasic
              register={register}
              type={'radio'}
              name={'HaveDependent'}
              label="Do you have any dependent children or other dependents?"
            />
          </div>
        </div>
        {HaveDep === 'yes' && (
          <>
            <>
              <div className="flex w-full mb-3 gap-4 ">
                <div className="w-1/4 mt-3  md-max:w-1/2 font-bold">
                  Dependent(s)
                </div>
                <div className="w-1/4 md-max:w-1/2">
                  <CustomButton
                    type="button"
                    prefix={<AddIcon />}
                    borderColor="white"
                    textColor="green"
                    bgColor="white"
                    onClick={() => append(emptyData)}
                  />
                </div>
              </div>
            </>
            <ul>
              {controlledFields.map((item, index) => (
                <li
                  className="border border-gray-100 pl-4 w-1/2 rounded-lg my-9 md-max:w-full"
                  key={item.id}
                >
                  <div className="my-3 mt-6 grid grid-cols-10 gap-4">
                    <p className="text-green text-base font-bold  col-start-1 col-end-7 ">
                      Dependent {index + 1}
                    </p>
                    <span
                      className="col-end-11 col-span-1 cursor-pointer lg-max:col-end-10"
                      onClick={() => {
                        remove(index);
                        setDeletedDep([...DeletedDep, item.serverId]);
                      }}
                    >
                      <CancelIcon className="text-gray-dark" />
                    </span>
                  </div>
                  <div className="flex mb-3">
                    <div className="w-2/3  md-max:w-full  md-max:mr-4">
                      <SelectInputBasic
                        control={control}
                        name={`dependents.${index}.relationship`}
                        label="Relationship"
                        options={RelationshipOptions}
                        type="select"
                        placeholder="Select.."
                      />
                    </div>
                  </div>
                  <div className="flex w-full mb-2 gap-2 ">
                    <div className="w-1/3  md-max:w-full">
                      <TextInputBasic
                        register={register}
                        name={`dependents.${index}.firstname`}
                        type={'text'}
                        label="First Name"
                      />
                    </div>
                    <div className="w-1/3  md-max:w-full  md-max:mr-4">
                      <TextInputBasic
                        register={register}
                        name={`dependents.${index}.lastname`}
                        type={'text'}
                        label="Last Name"
                      />
                    </div>
                  </div>

                  <div className="flex w-full mb-3">
                    <div className="w-2/3  md-max:w-full  md-max:mr-4">
                      <MaskedInputBasic
                        control={control}
                        name={`dependents.${index}.ssn`}
                        label="Social Security Number"
                        mask="999-99-9999"
                        type="maskedInput"
                        placeholder="SSN"
                      />
                    </div>
                  </div>

                  <div className="flex w-full mb-3">
                    <div className="w-2/3  md-max:w-full  md-max:mr-4">
                      <DateInputBasic
                        control={control}
                        name={`dependents.${index}.birth_date`}
                        type={'date'}
                        placeholder={'mm/dd/yyyy'}
                        label="Date of Birth"
                      />
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </>
        )}
        <div className="w-1/6 flex flex-inline gap-4 mt-6  md-max:w-full">
          <CustomButton type="submit" text="Save & Continue" />
        </div>
      </>
    </form>
  );
}
